$('.scroll-down__button').on('click', function() {
    $('html, body').animate({
        scrollTop: $(window).height()
    }, 500);
});

$('.form__scroll-down').on('click', function() {
    $('html, body').animate({
        scrollTop: 0,
    }, 500);
});

$(document).on('click', 'a[href^="#"]', function(e) {
    e.preventDefault();
    let target = $(document.getElementById($(this).attr('href').replace('#', '')));

    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top  - $('header').outerHeight(),
      }, 1000, 'swing');
    }
  });
